/**
 * Test-SCO-Model
 * @class service_v3sTest
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sSco
 */
angular.module('v3sWbtPlayerApp').factory('v3sTest', ["$q", "v3sModal", "v3sItem", "v3sTestSection", "v3sExerciseService", "v3sArrayService", function ($q, v3sModal, v3sItem, v3sTestSection, v3sExerciseService, v3sArrayService) {

    // instantiate the sco object
    var v3sTest = function (data, options) {
        // use the original item object constructor
        v3sTestSection.apply(this, arguments);
        this.scoredItems = 1;

        this.config = {};
        this.defaultConfig = {
            exam: {
                pots: null,
                evaluateAllSelected: true,
                evaluationVisible: false,
                evaluationVisibleAfterFinished: false,
                generalFeedbackVisible: false
            },
            examWithSolution: {
                pots: null,
                evaluateAllSelected: true,
                evaluationVisible: false,
                evaluationVisibleAfterFinished: true,
                generalFeedbackVisible: true
            },
            exercise: {
                pots: null,
                evaluateAllSelected: true,
                evaluationVisible: true,
                evaluationVisibleAfterFinished: true,
                generalFeedbackVisible: true
            }
        };

        this.review = false;       
        this.running = false;
        this.finished = false;
        this.attempt = 0;

        this.type = "exam";

        if (!!options) {
            this.masteryscore = parseInt(options.masteryscore) || 100;
            if (!!options.type && !!this.defaultConfig[options.type]) {
                this.type = options.type;
            }
        }

        this.loadConfig(this.defaultConfig[this.type]);
    };

    // use the original v3sSco prototype
    v3sTest.prototype = new v3sTestSection();

    /**
    * Setzt Review-Modus
    * @memberOf v3sWbtPlayerApp:model.service_v3sTest
    */
    v3sTest.prototype.setReview = function (review) {
        this.review = review;
    };

    /**
    * Gibt an, ob Review-Modus aktiv ist
    * @memberOf v3sWbtPlayerApp:model.service_v3sTest
    */
    v3sTest.prototype.isReview = function () {
        return this.review;
    };

    /**
    * Gibt Test zurück.
    * @memberOf v3sWbtPlayerApp:model.service_v3sTest
    */
    v3sTest.prototype.getTest = function () {
        return this;
    };

    v3sTest.prototype.loadConfig = function (config) {
        if (!!config) {
            angular.extend(this.config, config);
        }
    };

    v3sTest.prototype.getConfig = function () {
        return this.config;
    };

    v3sTest.prototype.create = function () {
        this.selectExercises();
        v3sArrayService.shuffle(this.allSelectedExercises, false, this.order);
    };

    v3sTest.prototype.start = function () {
        if (!this.running) {
            if (this.allSelectedExercises.length == 0 || this.finished) {
                this.reset();
                this.create();
            }
            this.running = true;
            this.finished = false;
            this.attempt++;           
        }
    };

    v3sTest.prototype.finish = function () {
        if (this.running) {
            v3sExerciseService.complete();
            this.running = false;
            this.finished = true;
            this.complete();
            this.notifyPageChanged(true);
            this.updateLastAccess();
        }
    };

    v3sTest.prototype.reset = function () {
        v3sTestSection.prototype.reset.call(this);
        this.running = false;
        this.finished = false;
        this.notifyPageChanged();
    };

    v3sTest.prototype.isRunning = function () {
        return this.running;
    };

    v3sTest.prototype.isFinished = function () {
        return this.finished;
    };

    v3sTest.prototype.areAllExercisesEvaluated = function () {
        for (var i = 0; i < this.allSelectedExercises.length; i++) {
            if (!this.allSelectedExercises[i].isEvaluated()) {
                return false;
            }
        }
        return true;
    };

    v3sTest.prototype.getAttempt = function () {
        return this.attempt;
    };

    v3sTest.prototype.isEvaluated = function () {
        return this.attempt > 0;
    };

    v3sTest.prototype.isLastEvaluated = function () {
        return this.attempt > 0;
    };

    v3sTest.prototype.getItem = function (id) {
        var item = null;
        if (!this.review && !!id) {
            if (this.id === id || this.path === id) {
                item = this;
            } else {
                for (var i = 0; i < this.allSelectedExercises.length; i++) {
                    if (this.allSelectedExercises[i].id === id || this.allSelectedExercises[i].path === id) {
                        item = this.allSelectedExercises[i];
                    }
                }
            }
        } else {
            item = v3sTestSection.prototype.getItem.call(this, id);
        }

        return item;
    };

    v3sTest.prototype.getChildren = function () {
        var children = null;
        if (!this.review) {
            children = this.allSelectedExercises;
        } else {
            children = v3sTestSection.prototype.getChildren.call(this);
        }
        return children;
    };

    v3sTest.prototype.getFirstChild = function () {
        var firstChild = this;
        if (this.running || this.finished) {
            if (!this.review) {
                firstChild = this.allSelectedExercises[0];
            } else {
                firstChild = v3sTestSection.prototype.getFirstChild.call(this);
            }
        }
        return firstChild;
    };

    v3sTest.prototype.getLastChild = function () {
        var lastChild = null;
        if (!this.review) {
            lastChild = this.allSelectedExercises[this.allSelectedExercises.length - 1];
        } else {
            lastChild = v3sTestSection.prototype.getLastChild.call(this);
        }
        return lastChild;
    };

    v3sTest.prototype.getPreviousChild = function (item) {
        var previousChild = null;

        if (!this.review) {
            for (var i = 1; i < this.allSelectedExercises.length; i++) {
                if (this.allSelectedExercises[i] === item) {
                    previousChild = this.allSelectedExercises[i - 1];
                }
            }
            if (!previousChild) {
                previousChild = this.parent.getPreviousChild(this);
            }
        } else {
            return v3sTestSection.prototype.getPreviousChild.call(this, item);
        }
        return previousChild;
    };

    v3sTest.prototype.getNextChild = function (item) {
        var nextChild = null;

        if (!this.review) {
            for (var i = 0; i < this.allSelectedExercises.length - 1; i++) {
                if (this.allSelectedExercises[i] === item) {
                    nextChild = this.allSelectedExercises[i + 1];
                }
            }

            if (!nextChild) {
                nextChild = this.parent.getNextChild(this);
            }
        } else {
            return v3sTestSection.prototype.getNextChild.call(this, item);
        }
        return nextChild;
    };

    v3sTest.prototype.allowEnter = function (toPage, confirm) {
        var allow = false;

        if (!!toPage && !!this.getItem(toPage.id)) {
            if (this.isRunning() || (this.isFinished() && this.config.evaluationVisibleAfterFinished)) {
                allow = true;
            } else {
                if (confirm != false) {
                    allow = this.confirmStart(toPage);
                }
            }
        } else {
            allow = true;
        }

        return allow;
    };

    v3sTest.prototype.allowExit = function (fromPage, toPage) {
        var allow = false;

        if (!this.isRunning() || (!!toPage && !!this.getItem(toPage.id))) {
            allow = true;
        } else {
            var allExercisesEvaluated = this.areAllExercisesEvaluated();
            if (this.config.evaluationVisible && allExercisesEvaluated) {
                this.finish();
                allow = true;
            } else {
                allow = this.confirmFinish(allExercisesEvaluated);
            }
        }

        return allow;
    };

    v3sTest.prototype.confirmStart = function (toPage) {
        var deferred = $q.defer();
        var self = this;
        var start = function () {
            self.start();
            var first = null;
            if (!self.review || !!toPage.getChildren) {
                first = self.getFirstChild();
            }
            deferred.resolve(first);  
        };

        if (this.review) {
            start();
        } else {
            var modal = v3sModal.show({
                title: "dialogs.test.title.start",
                message: "dialogs.test.message.start",
                customClass: "test",
                actions: {
                    "dialogs.test.buttons.start": function () {
                        start();
                        v3sModal.hide(modal);
                    },
                    "dialogs.test.buttons.cancel": function () {
                        v3sModal.hide(modal);
                    }
                },
                onHide: function () {
                    deferred.reject();
                }
            });
        }

        return deferred.promise;
    };

    v3sTest.prototype.confirmFinish = function (allExercisesEvaluated) {
        var deferred = $q.defer();
        var self = this;
        var finish = function () {
            self.finish();
            deferred.resolve(self.getNextChild(self.getLastChild()));
        };

        if (this.review) {
            finish();
        } else {
            var modal = v3sModal.show({
                title: "dialogs.test.title.evaluation",
                message: allExercisesEvaluated ? "dialogs.test.message.exercises_completed" : "dialogs.test.message.exercises_not_completed",
                customClass: "test",
                actions: {
                    "dialogs.test.buttons.evaluate": function () {
                        finish();
                        v3sModal.hide(modal);
                    },
                    "dialogs.test.buttons.cancel": function () {
                        v3sModal.hide(modal);
                    }
                },
                onHide: function () {
                    deferred.reject();
                }
            });
        }

        return deferred.promise;
    };

    v3sTest.prototype.getChangeCount = function () {
        return this.changed && this.finished ? 100 : 0;
    };

    v3sTest.prototype.resetData = function () {
        this.reset();
        this.attempt = 0;

        v3sTestSection.prototype.resetData.call(this);
    };

    v3sTest.prototype.getProgress = function () {
        return v3sItem.prototype.getProgress.call(this);
    };

    v3sTest.prototype.getScormData = function () {
        //obsolete
    };

    v3sTest.prototype.setScormData = function (data) {
        //obsolete
        if (!!data && data.length > 1) {
            v3sItem.prototype.setScormData.call(this, data);

            if (!!data[this.ScormDataEnum.TEST_DATA] > 0) {
                this.attempt = data[this.ScormDataEnum.TEST_DATA][0];
                this.lastAccess = data[this.ScormDataEnum.TEST_DATA][1];
            }
        }
    };

    v3sTest.prototype.getGlobalScormData = function (data) {
        v3sItem.prototype.getGlobalScormData.call(this, data);
        v3sTestSection.prototype.getGlobalScormData.call(this, data);

        if (!!data && this.attempt > 0) {
            var scormData = data[this.id] || [];
            scormData[this.ScormDataEnum.TEST_DATA] = [this.attempt, this.lastAccess];
            data[this.id] = scormData;
        }
    };

    v3sTest.prototype.setGlobalScormData = function (data) {
        v3sItem.prototype.setGlobalScormData.call(this, data);
        v3sTestSection.prototype.setGlobalScormData.call(this, data);

        if (!!data && !!data[this.id] && data[this.id].length > 0 &&
            !!data[this.id][this.ScormDataEnum.TEST_DATA] &&
            !!data[this.id][this.ScormDataEnum.TEST_DATA].length > 0) {
            this.attempt = parseInt(data[this.id][this.ScormDataEnum.TEST_DATA][0], 10) || 0;
            this.lastAccess = parseInt(data[this.id][this.ScormDataEnum.TEST_DATA][1], 10) || 0;
        }
    };

    v3sTest.prototype.getIndexOfQuestion = function (question) {
        var exercises = this.allSelectedExercises;
        var index = -1;
        for (var i = 0; i < exercises.length; i++) {
            if (question == exercises[i]) {
                return i + 1;
            }
        }
        return -1;
    };

    return v3sTest;
}]);
